import { PurchaseRequestProductRequestBody } from "./PurchaseRequestProductRequestBody";

export interface PurchaseRequestBody {
  vendor_id?: number;
  warehouse_id?: string;
  expected_delivery_date?: Date | string;
  is_urgent_sourcing_request?: boolean;
  pr_products?: PurchaseRequestProductRequestBody[];
  vendor_payment_term?: number;
  subtotal?: number;
  total_tax?: number;
  total_amount?: number;
  city_id?: string;
  city_name?: string;
  warehouse_name?: string;
  vendor_name?: string;
  vendor_email?: string;
  emails?: string[];
  other_charges?: number;
}

export enum PurchaseRequestRejectedBy {
  FINANCE = "FINANCE",
  SOURCING = "SOURCING",
  SWAGEAZY = "SWAGEAZY",
}

export const PurchaseOrderStatusOptions = [
  { id: "OPEN", value: "Open" },
  { id: "CREATED", value: "Created" },
  { id: "CLOSED", value: "Closed" },
  { id: "CANCELLED", value: "Cancelled" },
];
